module.exports = __webpack_public_path__ + "img/bg2.6771437e.jpg";